import { LASER_TAG_VALUE, StoreOfferProduct } from '@common'
import cx from 'classnames'
import { useTranslations } from 'next-intl'

import { SpecialOfferRibbonSVG } from './SpecialOfferRibbonSVG'
import { StoreTypography } from '../typography/StoreTypography'

import styles from './SpecialOfferRibbon.module.scss'

type SpecialOfferRibbonProps = {
  product: StoreOfferProduct
  type: 'extra' | 'off'
}

const defaultTagValueExtractor = (valueTagStrings: string[]) => (product: { tags?: string[] }) =>
  product?.tags
    ?.find((tag) => valueTagStrings.some((t) => tag.includes(t)))
    ?.split(':')
    .filter(Boolean)
    .pop()

export const SpecialOfferRibbon = ({ product, type }: SpecialOfferRibbonProps) => {
  const t = useTranslations()
  const percentage = Number(defaultTagValueExtractor([LASER_TAG_VALUE])(product))

  // defaults to purple if we have type
  const ribbonColor = type ? 'purple' : 'red'

  const ribbonContent =
    type === 'extra'
      ? t('offer_ribbon_extra', {
          percent: percentage,
        })
      : t('offer_ribbon_off', {
          percent: percentage,
        })

  return (
    <div className={cx(styles.container, { [styles[type]]: type })}>
      <SpecialOfferRibbonSVG color={ribbonColor} />

      <StoreTypography tag="h3" style="outlined" textSize="body" className={styles.textContent}>
        {ribbonContent}
      </StoreTypography>
    </div>
  )
}
